<template>
  <div>
    <CContainer class="mb-4">
      <CRow>
        <CCol md="4">
          <CButton class="w-100" color="success" @click="() => { modalVisible.insert = true }">
            <div class="button-text">
              <CIcon name="cil-plus" />
              <span>New</span>
            </div>
          </CButton>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Loader -->
    <CContainer class="d-flex justify-content-center" v-if="isLoad">
      <CSpinner color="primary" size="lg"/>
    </CContainer>
    <CContainer v-else>
      <CRow v-if="cities.length">
        <CCol 
          sm="4"
          v-for="city in cities" 
          :key="city.id"
        >
          <CCard>
            <CCardBody>
              <CCardTitle>{{ city.city_name }}</CCardTitle>
              <CCardText>{{ moneyFormatter(city.delivery_cost) }}</CCardText>
              <CButton class="mr-2" color="primary" variant="ghost" @click="handleEdit(city)">
                <div class="button-text">
                  <CIcon name="cil-pencil" />
                  <span>Edit</span>
                </div>
              </CButton>
              <CButton color="danger" variant="ghost" @click="() => { 
                modalVisible.delete = true 
                id = city.id
              }">
                <div class="button-text">
                  <CIcon name="cil-trash" />
                  <span>Delete</span>
                </div>
              </CButton>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
    <!-- Modal -->
    <CModal
      :show.sync="modalVisible.insert"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <CRow>
        <CCol md="12">
          <CForm class="w-100">
            <div class="mb-3">
              <CInput
                label="City Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide the city name."
                v-model="cityName"
                :is-valid="cityNameValidator"
              />
              <CInput
                label="Delivery Cost"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide numeric value."
                v-model="deliveryCost"
                :is-valid="deliveryCostValidator"
              >
                <template #prepend-content>RM</template>
              </CInput>
            </div>
          </CForm>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Insert City</h5>
        <CButtonClose @click="dismissModal" class="text-black"/>
      </template>
      <template #footer>
        <CButton @click="handleInsert" color="primary" :disabled="!isValidatePass">Save</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
    <CModal
      :show.sync="modalVisible.edit"
      :closeOnBackdrop="false"
      :centered="true"
    >
      <CRow>
        <CCol md="12">
          <CForm class="w-100">
            <div class="mb-3">
              <CInput
                label="City Name"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide the city name."
                v-model="cityName"
                :is-valid="cityNameValidator"
              />
              <CInput
                label="Delivery Cost"
                valid-feedback="Input is valid."
                invalid-feedback="Please provide numbers only."
                v-model="deliveryCost"
                :is-valid="deliveryCostValidator"
              >
                <template #prepend-content>RM</template>
              </CInput>
            </div>
          </CForm>
        </CCol>
      </CRow>
      <template #header>
        <h5 class="modal-title">Edit City</h5>
        <CButtonClose @click="dismissModal" class="text-black"/>
      </template>
      <template #footer>
        <CButton @click="handleSave" color="primary" :disabled="!isValidatePass">Save</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
    <CModal
      title="Modal title"
      color="danger"
      :closeOnBackdrop="false"
      :centered="true"
      :show.sync="modalVisible.delete"
    >
      Are you sure you want to delete this item ?
      <template #header>
        <h5 class="modal-title">Delete City</h5>
        <CButtonClose @click="dismissModal" class="text-white"/>
      </template>
      <template #footer>
        <CButton @click="handleDelete(id)" color="danger">OK</CButton>
        <CButton @click="dismissModal" color="secondary">Cancel</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import { 
  CITY_CREATE,
  CITY_UPDATE,
  CITY_DELETE,
  CITY_GET, 
} from '../../../constants/api'

import axios from 'axios'
import moneyFormatter from '../../../utils/moneyFormatter'

export default {
  data () {
    return {
      moneyFormatter,
      id: '',
      cityName: '',
      cities: [],
      deliveryCost: 0,
      validatePass: {
        cityName: false,
        deliveryCost: false,
      },
      modalVisible: {
        edit: false,
        insert: false,
        delete: false,
      },
      isLoad: false,
      accessToken: sessionStorage.getItem('access_token') || '',
    }
  },

  computed: {
    isValidatePass () {
      return this.validatePass.cityName && this.validatePass.deliveryCost
    }
  },

  beforeMount () {
    this.fetchCity()
  },

  methods: {
    fetchCity () {
      this.isLoad = true

      axios.get(CITY_GET, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
        .then(res => {
          this.cities = res.data.data
          this.isLoad = false
          this.dismissModal()
        })
    },

    handleEdit (city) {
      const { id, city_name, delivery_cost } = city

      this.id = id
      this.cityName = city_name
      this.deliveryCost = delivery_cost

      this.modalVisible.edit = true
    },

    handleInsert () {
      const payload = {
        name: this.cityName,
        deliveryCost: this.deliveryCost,
      }
      axios.post(CITY_CREATE, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })

      this.fetchCity()
    },

    handleDelete (id) {
      axios.delete(`${CITY_DELETE}${id}`, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
      this.fetchCity()
    },

    handleSave () {
      const payload = {
        name: this.cityName,
        deliveryCost: this.deliveryCost,
      }
      axios.put(`${CITY_UPDATE}${this.id}`, payload, {
        headers: {
          'x-access-token': this.accessToken
        }
      })
      this.fetchCity()
    },

    dismissModal () {
      this.id = ''
      this.cityName = ''
      this.deliveryCost = 0
      this.modalVisible.edit = false
      this.modalVisible.delete = false
      this.modalVisible.insert = false
    },

    // validator
    cityNameValidator (val) {
      if (val.length > 0) {
        this.validatePass.cityName = true
        return true
      } else {
        this.validatePass.cityName = false
        return false
      }
    },

    deliveryCostValidator (val) {
      if (!isNaN(val)) {
        this.validatePass.deliveryCost = true
        return true
      } else {
        this.validatePass.deliveryCost = false
        return false
      }
    },
  }  
}
</script>

<style scoped>
  .button-text {
    align-items: center;
    display: flex;
    justify-content: center;
  }
  .button-text > span {
    margin-left: 6px;
  }
</style>